// extracted by mini-css-extract-plugin
module.exports = {"easter":"styles-module--easter--3xcki","loader":"styles-module--loader--2bM9Z"};